import React from "react";
import productService from "../services/productService";
import { showProcess, hideProcess, getFileServer, UserSession, getUrlApi } from "../utils/util";
import { Galleria } from "primereact/galleria";
import shoppingCartService from "../services/shoppingCartService";
import bannersService from "../services/bannersService";
import { Paginator } from "primereact/paginator";

export default class Companies extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount() {
        
    }

    render() {
       return (
            <>
                <img src={require("../img/Banners site OC_empresas_3-03.png")} alt="Banner Empresas" style={{width: "100%", height: "auto"}}/>

                <div style={{width: "100%", textAlign: "center", marginTop: "100px", marginBottom: "100px"}}>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "43px", fontWeight: "600"}}>
                        As Melhores vantagens para sua empresa
                    </label>
                    <br/>
                    <br/>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "29px", fontWeight: "500"}}>
                        Encontre as opções perfeitas de recompensa, físicas ou digitais
                    </label>
                </div>

                <div style={{width: "100%", display: "flex"}}>
                    <div style={{width: "25%", display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)", padding: "50px", margin: "20px", borderRadius: "20px"}} >
                        <img src={require("../img/Grupo 33.png")} style={{width: "100px", marginBottom: "20px"}}/>
                        <label style={{color: "var(--unnamed-color-411172)", fontSize: "20px", fontWeight: "500"}}>
                            Reconhecer os melhores desempenhos
                        </label>
                    </div>
                    <div style={{width: "25%", display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)", padding: "50px", margin: "20px", borderRadius: "20px"}} >
                        <img src={require("../img/Grupo 35.png")} style={{width: "100px", marginBottom: "20px"}}/>
                        <label style={{color: "var(--unnamed-color-411172)", fontSize: "20px", fontWeight: "500"}}>
                            Comemore o atingimento de metas e objetivos
                        </label>
                    </div>
                    <div style={{width: "25%", display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)", padding: "50px", margin: "20px", borderRadius: "20px"}} >
                        <img src={require("../img/Grupo 37.png")} style={{width: "100px", marginBottom: "20px"}}/>
                        <label style={{color: "var(--unnamed-color-411172)", fontSize: "20px", fontWeight: "500"}}>
                            Incentive treinamentos, pesquisas e programas de bem-estar
                        </label>
                    </div>
                    <div style={{width: "25%", display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)", padding: "50px", margin: "20px", borderRadius: "20px"}} >
                        <img src={require("../img/Grupo 40.png")} style={{width: "100px", marginBottom: "20px"}}/>
                        <label style={{color: "var(--unnamed-color-411172)", fontSize: "20px", fontWeight: "500"}}>
                            Incentive treinamentos, pesquisas e programas de bem-estar
                        </label>
                    </div>
                </div>

                <div style={{width: "100%", textAlign: "center", marginTop: "100px", marginBottom: "100px"}}>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "43px", fontWeight: "600"}}>
                        Nosso portfolio é diversificado e completo para surpreender sempre
                    </label>
                    <br/>
                    <br/>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "29px", fontWeight: "500"}}>
                        Os cartões-presente são acertivos, use isso a favor das suas campanhas.
                    </label>
                </div>

                <img src={require("../img/Grupo 375.png")} alt="Banner Empresas" style={{width: "100%", height: "auto"}}/>

                <label style={{color: "#a7a7a7", fontSize: "15px", fontWeight: "600"}}>
                    *Nas versões físicas e/ou digital.
                </label>

                <br/>
                <br/>
                <div style={{width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <a href="https://blackhawknetwork.com/br-pt" target="_blank" style={{width: "100%", textAlign: "center", marginTop: "50px", marginBottom: "50px", color: "var(--unnamed-color-411172)", fontSize: "29px", fontWeight: "500"}}>
                        Veja nosso catálogo completo de marcas.
                    </a>
                </div>
                
                

                <div style={{width: "100%", textAlign: "center", marginTop: "20px", marginBottom: "100px"}}>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "43px", fontWeight: "600"}}>
                        Precisa comprar em lote, maiores quantidades ou cartões-presente de outras marcas?
                    </label>
                    <br/>
                    <br/>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "29px", fontWeight: "500"}}>
                        Você passa qual a sua necessidade e nós resolvemos todo o resto.
                        <br/>
                        Fale com um dos nossos especialistas!
                    </label>
                    <br/>
                    <br/>
                    <br/>
                    <button onClick={() => window.location.href = "https://api.whatsapp.com/send/?phone=5511942505855&text=Ol%C3%A1%2C+gostaria+de++saber+mais+sobre+a+BHN&type=phone_number&app_absent=0"}
                            style={{backgroundColor: "var(--unnamed-color-411172)", color: "#fff", border: "none", borderRadius: "50px", padding: "20px 80px", fontSize: "30px", cursor: "pointer", fontWeight: "600"}}>Entrar em contato</button>
                </div>
            </>
        );
    }
}
